import { useQuery } from "@tanstack/react-query";

import { Organization } from "@/components/common/OrganizationSwitcher/types";
import { EntityKey } from "@/components/common/Search/types";

import {
  OrganizationsResponse,
  OwnerOrdIdResponse,
} from "@/features/auth/types";

import { baseClient } from "@/utils/remote";

export const fetchOrganizations = () =>
  baseClient.get<{ organization: Organization[] }>(
    "organizations:list?returnOwnOrg=true",
  );

export const useOrganizationsQuery = () => {
  return useQuery<OrganizationsResponse>({
    queryKey: ["orgs"],
    queryFn: () =>
      baseClient
        .get("organizations:list?returnOwnOrg=true")
        .then((response) => response.data),
  });
};

export const useOwnerOrganizations = (
  entity: EntityKey,
  entityId: string,
  error?: Error,
) => {
  let keyName: string = "";
  switch (entity) {
    case "alert":
      keyName = "alert_id";
      break;
    case "device":
      keyName = "device_id";
      break;
    case "trip":
      keyName = "internal_trip_id";
      break;
    case "asset":
      keyName = "internal_asset_id";
      break;
    case "reader":
      keyName = "reader_id";
      break;
    default:
      throw new Error("Entity is not allowed");
  }
  // Use baseClient here to avoid sending the `Chorus-view-as-org` header.
  // This ensures the Role remains ADMIN in the callContext, allowing the modal to appear for ADMINs regardless of the currently selected organization.
  return useQuery<OwnerOrdIdResponse>({
    queryKey: [keyName],
    queryFn: async () => {
      return baseClient
        .get(`vis/organizations/ownerOrg?${keyName}=${entityId}`)
        .then((response) => response.data);
    },
    enabled: !!error,
  });
};
